export const SUPPORT_EMAIL = "support@retroboard.net";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
